var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"aha-button",class:[
    `aha-button-${_vm.size}`,
    `aha-button-${_vm.variant}`,
    {
      'mr-4': _vm.hasMarginRight,
      'ml-4': _vm.hasMarginLeft,
    }
  ],attrs:{"type":"button","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click', $event)}}},[(_vm.iconName.length && !_vm.submitting)?_c('aha-icon',{staticClass:"mr-1",attrs:{"name":_vm.iconName,"height":"18","width":"20","viewBox":"0 0 24 24"}}):_vm._e(),_vm._t("default"),(_vm.submitting && !_vm.iconName.length)?_c('aha-spinner',{staticClass:"ml-2",attrs:{"variant":_vm.variant !== 'base' ? 'white' : 'dark'}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }